<template>
  <div class="relative">
    <button
      type="button"
      class="
        block
        h-8
        w-8
        rounded-full
        overflow-hidden
        border-2
        focus:outline-none focus:border-green-400
      "
      @click="toggleMenuDropdown"
    >
      <img
        class="h-full w-full object-cover"
        src="../assets/avatar_default.png"
        alt="Avatar"
      />
    </button>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div
        v-if="isOpen"
        class="
          origin-top-right
          absolute
          right-0
          mt-2
          w-56
          rounded-md
          shadow-lg
          bg-white
          ring-1 ring-black ring-opacity-5
          focus:outline-none
        "
        tabindex="-1"
        v-on-clickaway="clickOutsideMenuDropdown"
      >
        <div class="py-1 divide-y divide-gray-100">
          <p
            class="
              text-base text-gray-700
              block
              truncate
              px-4
              py-2
              cursor-default
            "
          >
            {{ currentUser ? currentUser.email : 'Account Name' }}
          </p>
          <button
            @click="onChangePassword"
            type="button"
            class="
              inline-flex
              items-center
              w-full
              text-base text-gray-700
              px-4
              py-2
              hover:bg-gray-100 hover:text-gray-900
              focus:outline-none
            "
          >
            เปลี่ยนรหัสผ่าน
          </button>
          <button
            @click="logout"
            type="button"
            class="
              inline-flex
              items-center
              w-full
              text-base text-gray-700
              px-4
              py-2
              hover:bg-gray-100 hover:text-gray-900
              focus:outline-none
            "
          >
            ออกจากระบบ
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-gray-600 ml-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],

  data() {
    return {
      isOpen: false,
    }
  },

  computed: {
    currentUser() {
      return this.$store.state.auth.currentUser
    },
  },

  methods: {
    toggleMenuDropdown() {
      this.isOpen = !this.isOpen
    },

    clickOutsideMenuDropdown() {
      this.isOpen = false
    },

    logout() {
      this.$store
        .dispatch('auth/logout')
        .then(() => this.$router.push({ name: 'Login' }))
    },

    onChangePassword() {
      this.$router.push({ name: 'ChangePassword' })
      this.isOpen = false
    },
  },
}
</script>
